import { MemberFields, memberGQLFields } from '../network/member.fields.js'
import { SpaceFields, spaceGQLFields } from '../space/space.fields.js'

export type LocaleGroupFields =
  | 'basic'
  | 'all'
  | 'default'
  | CustomLocaleGroupFields

export interface CustomLocaleGroupFields {
  primarySpace?: SpaceFields
  spaces?: SpaceFields
  createdBy?: MemberFields
}

const BASIC_LOCALE_GROUP_FIELDS: CustomLocaleGroupFields = {}
const ALL_LOCALE_GROUP_FIELDS: CustomLocaleGroupFields = {
  primarySpace: 'basic',
  spaces: 'basic',
  createdBy: 'basic',
}
const DEFAULT_LOCALE_GROUP_FIELDS: CustomLocaleGroupFields = {
  primarySpace: 'basic',
  spaces: 'basic',
}

export function localeGroupGQLFields(fields: LocaleGroupFields): string {
  if (fields === 'basic') {
    fields = BASIC_LOCALE_GROUP_FIELDS
  }
  if (fields === 'all') {
    fields = ALL_LOCALE_GROUP_FIELDS
  }
  if (fields === 'default') {
    fields = DEFAULT_LOCALE_GROUP_FIELDS
  }

  return `
    id
    networkId
    name
    description
    slug
    primarySpaceId
    basePath
    createdById
    createdAt
    updatedAt
    ${
      fields.primarySpace
        ? `
      primarySpace {
        ${spaceGQLFields(fields.primarySpace)}
      }
    `
        : ``
    }
    ${
      fields.spaces
        ? `
      spaces {
        ${spaceGQLFields(fields.spaces)}
      }
    `
        : ``
    }
    ${
      fields.createdBy
        ? `
      createdBy {
        ${memberGQLFields(fields.createdBy)}
      }
    `
        : ``
    }
  `
}
